<!--
 * @Author: guoyu
 * @Date: 2020-09-17 15:38:52
 * @LastEditors: your name
 * @LastEditTime: 2020-09-21 12:33:07
 * @Description: 多行輸入輸入
-->
<template>
  <div class="text-area-container">
    <textarea class="input-area" v-model="text" :maxlength="maxlength" v-bind="$attrs"></textarea>
    <p class="count-text">
      <span>{{ text.length }}/{{ maxlength }}</span>
    </p>
  </div>
</template>
<script>
export default {
  model: {
    event: 'inputChange',
    prop: 'val',
  },
  props: {
    maxlength: {
      type: [String, Number],
      default: 200,
    },
    val: {
      type: [String, Number],
      default: '',
    },
  },
  computed: {
    text: {
      get() {
        return this.val;
      },
      set(newVal) {
        this.$emit('inputChange', newVal);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.text-area-container {
  position: relative;
  overflow: hidden;
  padding: 12px;
  border: 1px solid #e9e9e9;
  box-sizing: border-box;
  background: $color-light;
  border-radius: 8px;
}
.input-area {
  width: 100%;
  min-height: 80px;
  font-size: 14px;
  line-height: 17px;
}
.count-text {
  margin-top: 3px;
  text-align: right;
  font-size: 12px;
  color: #afafaf;
  line-height: 16px;
}
</style>
